import "./CellEditableDefault.css";

import { useDispatch } from "react-redux";

import CreateIcon from "@mui/icons-material/Create";

const CellEditableDefault = ({ style, clmName, clickedTableClmName, props, rowObj, cellTitle, cellValue, colSpan }) => {
	const dispatch = useDispatch();

	return (
		<td
			className="TableCell"
			clm={clmName}
			title={cellTitle == null ? "" : cellTitle.toString()}
			style={style}
			is_clicked_clm_name={String(clmName === clickedTableClmName)}
			colSpan={colSpan}
			onClick={(e) => {
				if (props.rowOptions.useEditIcon !== false && rowObj.id !== "-1" && ["svg", "path"].includes(e.target.tagName)) {
					const editObj = { key: rowObj["key"], inline_cell: clmName };
					if (props.func["editData"] != null) {
						dispatch(props.func["editData"](editObj));
					} else if (props.func["editDataLocal"] != null) {
						props.func["editDataLocal"](props.tableData, editObj);
					} else if (props.func["editDataFactory"] != null) {
						props.func["editDataFactory"]({ rowObj: rowObj, dataObj: editObj });
					}
				}
			}}
		>
			<div className="TableCellEditable">
				<div className="TableCellEditableValue">{cellValue}</div>
				{props.rowOptions.useEditIcon !== false && rowObj.id !== "-1" && <CreateIcon className="editData_btn" />}
			</div>
		</td>
	);
};

export default CellEditableDefault;
